/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createLegacyEntry = /* GraphQL */ `
  mutation CreateLegacyEntry(
    $input: CreateLegacyEntryInput!
    $condition: ModelLegacyEntryConditionInput
  ) {
    createLegacyEntry(input: $input, condition: $condition) {
      id
      userId
      title
      content
      type
      photoPath
      voiceConversationId
      packId
      promptId
      writerVersion
      createdAt
      owner
      updatedAt
      __typename
    }
  }
`;
export const updateLegacyEntry = /* GraphQL */ `
  mutation UpdateLegacyEntry(
    $input: UpdateLegacyEntryInput!
    $condition: ModelLegacyEntryConditionInput
  ) {
    updateLegacyEntry(input: $input, condition: $condition) {
      id
      userId
      title
      content
      type
      photoPath
      voiceConversationId
      packId
      promptId
      writerVersion
      createdAt
      owner
      updatedAt
      __typename
    }
  }
`;
export const deleteLegacyEntry = /* GraphQL */ `
  mutation DeleteLegacyEntry(
    $input: DeleteLegacyEntryInput!
    $condition: ModelLegacyEntryConditionInput
  ) {
    deleteLegacyEntry(input: $input, condition: $condition) {
      id
      userId
      title
      content
      type
      photoPath
      voiceConversationId
      packId
      promptId
      writerVersion
      createdAt
      owner
      updatedAt
      __typename
    }
  }
`;
export const createShareableMedia = /* GraphQL */ `
  mutation CreateShareableMedia(
    $input: CreateShareableMediaInput!
    $condition: ModelShareableMediaConditionInput
  ) {
    createShareableMedia(input: $input, condition: $condition) {
      id
      shareId
      storyId
      userId
      mediaType
      s3Key
      title
      storytellerName
      photoS3Key
      sourceType
      createdAt
      owner
      updatedAt
      __typename
    }
  }
`;
export const updateShareableMedia = /* GraphQL */ `
  mutation UpdateShareableMedia(
    $input: UpdateShareableMediaInput!
    $condition: ModelShareableMediaConditionInput
  ) {
    updateShareableMedia(input: $input, condition: $condition) {
      id
      shareId
      storyId
      userId
      mediaType
      s3Key
      title
      storytellerName
      photoS3Key
      sourceType
      createdAt
      owner
      updatedAt
      __typename
    }
  }
`;
export const deleteShareableMedia = /* GraphQL */ `
  mutation DeleteShareableMedia(
    $input: DeleteShareableMediaInput!
    $condition: ModelShareableMediaConditionInput
  ) {
    deleteShareableMedia(input: $input, condition: $condition) {
      id
      shareId
      storyId
      userId
      mediaType
      s3Key
      title
      storytellerName
      photoS3Key
      sourceType
      createdAt
      owner
      updatedAt
      __typename
    }
  }
`;
export const createUserData = /* GraphQL */ `
  mutation CreateUserData(
    $input: CreateUserDataInput!
    $condition: ModelUserDataConditionInput
  ) {
    createUserData(input: $input, condition: $condition) {
      id
      userId
      recipients
      shares
      capsules
      accountSettings
      legacyBook
      collections
      journal
      memoryCareSubjects
      celebrationBooks
      lastUpdated
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateUserData = /* GraphQL */ `
  mutation UpdateUserData(
    $input: UpdateUserDataInput!
    $condition: ModelUserDataConditionInput
  ) {
    updateUserData(input: $input, condition: $condition) {
      id
      userId
      recipients
      shares
      capsules
      accountSettings
      legacyBook
      collections
      journal
      memoryCareSubjects
      celebrationBooks
      lastUpdated
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteUserData = /* GraphQL */ `
  mutation DeleteUserData(
    $input: DeleteUserDataInput!
    $condition: ModelUserDataConditionInput
  ) {
    deleteUserData(input: $input, condition: $condition) {
      id
      userId
      recipients
      shares
      capsules
      accountSettings
      legacyBook
      collections
      journal
      memoryCareSubjects
      celebrationBooks
      lastUpdated
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createStoryDraft = /* GraphQL */ `
  mutation CreateStoryDraft(
    $input: CreateStoryDraftInput!
    $condition: ModelStoryDraftConditionInput
  ) {
    createStoryDraft(input: $input, condition: $condition) {
      id
      userId
      title
      wholeTitle
      wholeContent
      flickTitle
      flickContent
      activeVersion
      promptId
      promptText
      packId
      bookId
      occasion
      voiceConversationId
      polishTier
      landingPlayedAt
      transcript
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStoryDraft = /* GraphQL */ `
  mutation UpdateStoryDraft(
    $input: UpdateStoryDraftInput!
    $condition: ModelStoryDraftConditionInput
  ) {
    updateStoryDraft(input: $input, condition: $condition) {
      id
      userId
      title
      wholeTitle
      wholeContent
      flickTitle
      flickContent
      activeVersion
      promptId
      promptText
      packId
      bookId
      occasion
      voiceConversationId
      polishTier
      landingPlayedAt
      transcript
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStoryDraft = /* GraphQL */ `
  mutation DeleteStoryDraft(
    $input: DeleteStoryDraftInput!
    $condition: ModelStoryDraftConditionInput
  ) {
    deleteStoryDraft(input: $input, condition: $condition) {
      id
      userId
      title
      wholeTitle
      wholeContent
      flickTitle
      flickContent
      activeVersion
      promptId
      promptText
      packId
      bookId
      occasion
      voiceConversationId
      polishTier
      landingPlayedAt
      transcript
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
